// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginPage_root__FdNIn","form":"LoginPage_form__2_lnB"};